import script from "./crop-image.vue?vue&type=script&setup=true&lang=ts"
export * from "./crop-image.vue?vue&type=script&setup=true&lang=ts"

import "./crop-image.vue?vue&type=style&index=0&id=cf066dde&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf066dde"]])

export default __exports__